<template>
  <div v-if="detailsCondition" class="rhcn-descriptions" :class="{ 'is-collapse': innerCollapse }">
    <el-descriptions :column="rowColumn" :colon="false">
      <template slot="title">
        <div class="rhcn-descriptions-title" :class="{ 'collapse': showCollapse }" @click="onExpandChange">
          <span class="topTitle">{{ $t(detailsCondition.topTitle) }}</span>
          <i v-if="showCollapse" class="el-icon-arrow-down" :class="{ 'is-reverse': innerCollapse }"></i>
        </div>
      </template>
      <template v-if="contentType === 'slot'">
        <el-descriptions-item class="custom-content" labelClassName="slot-label">
          <slot name="content"></slot>
        </el-descriptions-item>
      </template>
      <template v-else>
        <template v-for="(item, index) in detailsCondition.listTemplate">
          <template v-if="showRowItems(item, index)">
            <template v-if="item.type === 'label-tips'">
              <el-descriptions-item :span="item.span ? item.span : 1" :key="index">
                <template slot="label">
                  {{ $t(item.titleBar.title) }}
                  <el-popover placement="right" popper-class="popper-dark" trigger="hover">
                    <div v-html="item.text"></div>
                    <template #reference>
                      <!-- <el-button type="text" icon="el-icon-warning-outline margin-left-20" size="mini"></el-button> -->
                      <img class="margin-left-20" style="vertical-align:sub;width:16px;height:16px;cursor:pointer;"
                        src="@/assets/images/base/icon-note.png" />
                    </template>
                  </el-popover>
                </template>
                <template>{{ item.isInternationalization ? $t(getDisplayText(item)) : getDisplayText(item) }}</template>
              </el-descriptions-item>
            </template>
            <template v-else-if="item.type === 'text-view'">
              <el-descriptions-item :span="item.span ? item.span : 1" :label="$t(item.titleBar.title)" :key="index">
                <template v-if="item.showLabelTips">
                  <template slot="label">
                    {{ $t(item.titleBar.title) }}
                    <el-popover placement="right" popper-class="popper-dark" trigger="hover">
                      <div v-html="item.text"></div>
                      <template #reference>
                        <img class="margin-left-20" style="vertical-align:sub;width:16px;height:16px;cursor:pointer;"
                          src="@/assets/images/base/icon-note.png" />
                      </template>
                    </el-popover>
                  </template>
                </template>
                <template v-if="detailsCondition.data[item.key]">
                  <TextView :text="item.isInternationalization ? $t(getDisplayText(item)) : getDisplayText(item)"
                    :type="item.textViewType" :desc="item.textViewDesc" @link="item.onLink ? item.onLink() : null">
                  </TextView>
                </template>
                <template v-else>
                  <span>--</span>
                </template>
              </el-descriptions-item>
            </template>
            <template v-else-if="item.type === 'html'">
              <el-descriptions-item :span="item.span ? item.span : 1" :label="$t(item.titleBar.title)" :key="index">
                <template>
                  <div v-html="item.isInternationalization ? $t(getDisplayText(item)) : getDisplayText(item)"></div>
                </template>
              </el-descriptions-item>
            </template>
            <template v-else-if="item.type === 'slot'">
              <el-descriptions-item :span="item.span ? item.span : 1" :label="$t(item.titleBar.title)" :key="index">
                <slot :name="item.key"></slot>
              </el-descriptions-item>
            </template>
            <template v-else-if="item.type === 'placeholder'">
              <el-descriptions-item :span="item.span ? item.span : 1" :key="index">
              </el-descriptions-item>
            </template>
            <template v-else>
              <el-descriptions-item :span="item.span ? item.span : 1" :label="$t(item.titleBar.title)" :key="index">
                <template>{{ item.isInternationalization ? $t(getDisplayText(item)) : getDisplayText(item) }}</template>
              </el-descriptions-item>
            </template>
          </template>
        </template>
      </template>
    </el-descriptions>
  </div>
</template>

<script>
import TextView from '@/components/form/text-view.vue';
import { isNullForDisplay } from '@/utils/tools/utils';

export default {
  name: 'RhcnDescriptions',
  components: { TextView },
  props: {
    isCollapse: {
      type: Boolean,
      default: true,
    },
    rowColumn: {
      type: Number,
      default: 2,
    },
    detailsCondition: {
      type: Object,
      default: () => { },
    },
    contentType: {
      type: String,
      default: '',
    },
    showCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerCollapse: this.isCollapse,
    };
  },
  methods: {
    onExpandChange() {
      if (!this.showCollapse) {
        return;
      }
      this.innerCollapse = !this.innerCollapse;
    },
    getDisplayText(item) {
      return (item.textFunc ? item.textFunc(this.detailsCondition.data) : (isNullForDisplay(this.detailsCondition.data[item.key], '--') || '--'));
    },
    showRowItems(item, index) {
      if (item.isDisplayFunc && !item.isDisplayFunc(this.detailsCondition.data)) {
        return false;
      }
      return true;
      // TODO 目前暂不控制行数
      // if (this.detailsCondition.showAll) {
      //   return true;
      // }
      // const initRows = this.detailsCondition.initRows || 5; // 初始化显示行数，默认 6 行，超出省略
      // const maxNum = (initRows * this.rowColumn);
      // return index < maxNum;
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.rhcn-descriptions {
  border: 1px solid rgba(239, 239, 244, 1);
  padding: 0 24px;
  padding-bottom: 12px;
  border-radius: 8px;
  height: 70px;
  overflow: hidden;
  box-sizing: border-box;
  transition: all .2s;

  &.is-collapse {
    height: auto;
    overflow: visible;
  }

  .el-descriptions__header {
    // height: 70px;
    margin-bottom: 24px;
    border-bottom: 1px solid rgba(239, 239, 244, 1);

    .el-descriptions__title {
      width: 100%;
      height: 100%;
    }

    .rhcn-descriptions-title {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 20px;
      font-weight: 700;
      line-height: 30px;
      text-align: left;
      color: $color-text-primary-new;

      .topTitle {
        margin-top: 24px;
        margin-bottom: 16px;
      }

      &.collapse {
        cursor: pointer;
      }
    }
  }

  .el-descriptions-item__cell {
    padding-bottom: 16px;
  }

  .el-descriptions-item__label {
    color: $color-description-new;
    font-weight: normal;
    line-height: 18px;
    font-size: 14px;
    width: 200px;
    min-width: 200px;

    &.slot-label {
      display: none;
    }

    .el-popover__reference-wrapper {
      display: inline-block;
    }

    .el-button--text {
      padding: 0;
      font-size: 14px;
      min-width: 0;
    }
  }

  .el-descriptions__body {
    // border-bottom: 1px solid rgba(239, 239, 244, 1);
  }

  .el-descriptions-item__content {
    color: $color-text-primary-new;
    word-break: break-all;
    font-weight: 500;
    line-height: 18px;
    font-size: 14px;
    margin-right: 20px;

    .el-button--text {
      padding: 0;
      font-size: 14px;
      min-width: 0;
    }

    .content-inner {
      position: relative;

      .sub-item-content {
        overflow: hidden;
        // max-height: 56px;
      }

      .show-more-btn {
        position: absolute;
        right: 0;
        bottom: 0;
        background: #FFFFFF;
        display: none;

        .ellipsis {
          padding-right: 15px;
        }

        a {
          cursor: pointer;
        }
      }

      &.has-more .show-more-btn {
        display: block;
      }
    }
  }
}

.popper-dark {
  background-color: black;
  color: #FFFFFF;
  font-size: 14px;
  border-radius: 8px;
  width: 295px;

  .popper__arrow {
    border-right-color: black !important;

    &::after {
      border-right-color: black !important;
    }
  }
}
</style>
